import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BranchSettingsFacade } from './facades/branch-settings.facade';
import { branchSettingsCacheReducers } from './view-cache-controller/store/reducers/root';
import { branchSettingsViewCacheFeatureKey } from './view-cache-controller/store/reducers/view-cache.reducers';
// import { BranchSettingsModule } from './branch-settings.module';

export const branchCacheStoreModule = StoreModule.forFeature(branchSettingsViewCacheFeatureKey, branchSettingsCacheReducers.branchSettingsViewCache);

@NgModule({
  imports: [
    CommonModule,
    // BranchSettingsModule,
    branchCacheStoreModule
  ],
  providers: [
    BranchSettingsFacade
  ]
})
export class BranchViewCacheModule {}
